import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AdminService} from '../../shared/services/admin.service';
import { environment } from '../../../environments/environment';

import { RouterModule } from '@angular/router';
import { TopbarComponent } from '../../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { BottombarComponent } from '../../shared/components/bottombar/bottombar.component';


@Component({
    selector: 'app-admin-details',
    templateUrl: './admin-details.component.html',
    styleUrls: ['./admin-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    RouterModule,
    TopbarComponent,
    SidebarComponent,
    BottombarComponent
]
})
export class AdminDetailsComponent implements OnInit {
data;
  constructor(private route: ActivatedRoute, private adminService: AdminService) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const slug = params.get('slug');
      this.getDetails(slug);
    });
  }

  getDetails(slug) {
    console.log('this ijfj', environment.production ? environment.baseApiUrl + 'admin/details/'  : environment.baseApiUrlTest + 'admin/details/')
    this.adminService.getAdmin(slug).subscribe(
      //  data => console.log(data)
      data => this.data = data
    );
     console.log('this is data resposne', this.data)
  }
  adminLevel($level) {
    if ($level === 'admin') {
      return 'ADMIN';
    }
    return 'SUPER ADMIN';
  }

}
